export * from './legend.component';
export * from './scale-legend.component';
export * from './legend-entry.component';
export * from './advanced-legend.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/release/common/legend/index.js
// module id = 1481
// module chunks = 3